export { default } from './TorchOne'
